// /app/frontend/src/components/frugal-v2/components/BottomNav.jsx
// Bottom navigation bar with 4 tabs (60 lines)

import React from 'react';
import { Home, PieChart, Wallet, Building2 } from 'lucide-react';

const TABS = {
  HOME: 'home',
  EXECUTION: 'execution',
  BUDGET: 'budget',
  ACCOUNTS: 'accounts'
};

const BottomNav = ({ activeTab, onTabChange, t }) => {
  const tabs = [
    { id: TABS.HOME, icon: Home, label: t('frugal.tabs.home') },
    { id: TABS.EXECUTION, icon: PieChart, label: t('frugal.tabs.execution') },
    { id: TABS.BUDGET, icon: Wallet, label: t('frugal.tabs.budget') },
    { id: TABS.ACCOUNTS, icon: Building2, label: t('frugal.tabs.accounts') || 'Cuentas' }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-slate-900/95 backdrop-blur-sm border-t border-white/10 z-40">
      <div className="max-w-lg mx-auto flex">
        {tabs.map(({ id, icon: Icon, label }) => (
          <button
            key={id}
            onClick={() => onTabChange(id)}
            className={`flex-1 flex flex-col items-center gap-1 py-3 transition-colors relative ${
              activeTab === id 
                ? 'text-emerald-400' 
                : 'text-slate-500 hover:text-slate-300'
            }`}
          >
            <Icon className="w-5 h-5" />
            <span className="text-xs">{label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export { TABS };
export default BottomNav;
